// extracted by mini-css-extract-plugin
module.exports = {"iframe":"dashboard_iframe__2KIHA","iframe-small":"dashboard_iframe-small__3_VFM"};